export const SEARCH_BOX_INPUT_PLACEHOLDER = 'Search...';
